module.exports = __webpack_public_path__ + "media/images/excel-icon-d9efa1e608779c0b55c556478391b434.png";